"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _classPrivateFieldLooseBase(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }

  return receiver;
}

var id = 0;

function _classPrivateFieldLooseKey(name) {
  return "__private_" + id++ + "_" + name;
}

function isFunction(v) {
  return typeof v === 'function';
}

function result(v) {
  return isFunction(v) ? v() : v;
}
/* Audio Oscilloscope
  https://github.com/miguelmota/audio-oscilloscope
*/


var _draw = /*#__PURE__*/_classPrivateFieldLooseKey("draw");

var AudioOscilloscope = /*#__PURE__*/function () {
  function AudioOscilloscope(canvas, options) {
    var _this = this;

    _classCallCheck(this, AudioOscilloscope);

    if (options === void 0) {
      options = {};
    }

    Object.defineProperty(this, _draw, {
      writable: true,
      value: function value() {
        return _this.draw();
      }
    });
    var canvasOptions = options.canvas || {};
    var canvasContextOptions = options.canvasContext || {};
    this.analyser = null;
    this.bufferLength = 0;
    this.dataArray = [];
    this.canvas = canvas;
    this.width = result(canvasOptions.width) || this.canvas.width;
    this.height = result(canvasOptions.height) || this.canvas.height;
    this.canvas.width = this.width;
    this.canvas.height = this.height;
    this.canvasContext = this.canvas.getContext('2d');
    this.canvasContext.fillStyle = result(canvasContextOptions.fillStyle) || 'rgb(255, 255, 255)';
    this.canvasContext.strokeStyle = result(canvasContextOptions.strokeStyle) || 'rgb(0, 0, 0)';
    this.canvasContext.lineWidth = result(canvasContextOptions.lineWidth) || 1;
    this.onDrawFrame = isFunction(options.onDrawFrame) ? options.onDrawFrame : function () {};
  }

  _createClass(AudioOscilloscope, [{
    key: "addSource",
    value: function addSource(streamSource) {
      this.streamSource = streamSource;
      this.audioContext = this.streamSource.context;
      this.analyser = this.audioContext.createAnalyser();
      this.analyser.fftSize = 2048;
      this.bufferLength = this.analyser.frequencyBinCount;
      this.source = this.audioContext.createBufferSource();
      this.dataArray = new Uint8Array(this.bufferLength);
      this.analyser.getByteTimeDomainData(this.dataArray);
      this.streamSource.connect(this.analyser);
    }
  }, {
    key: "draw",
    value: function draw() {
      var analyser = this.analyser,
          dataArray = this.dataArray,
          bufferLength = this.bufferLength;
      var ctx = this.canvasContext;
      var w = this.width;
      var h = this.height;

      if (analyser) {
        analyser.getByteTimeDomainData(dataArray);
      }

      ctx.fillRect(0, 0, w, h);
      ctx.beginPath();
      var sliceWidth = w * 1.0 / bufferLength;
      var x = 0;

      if (!bufferLength) {
        ctx.moveTo(0, this.height / 2);
      }

      for (var i = 0; i < bufferLength; i++) {
        var v = dataArray[i] / 128.0;
        var y = v * (h / 2);

        if (i === 0) {
          ctx.moveTo(x, y);
        } else {
          ctx.lineTo(x, y);
        }

        x += sliceWidth;
      }

      ctx.lineTo(w, h / 2);
      ctx.stroke();
      this.onDrawFrame(this);
      requestAnimationFrame(_classPrivateFieldLooseBase(this, _draw)[_draw]);
    }
  }]);

  return AudioOscilloscope;
}();

module.exports = AudioOscilloscope;